import React, { useState, useContext, useEffect } from "react";
import { GlobalContext } from "../../App";
import { NavLink, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import files from "../static";
import "./Form.css";
import { HOST } from "../host";
import OTP from "./otp";
import V1 from "../authbg.mp4";
import { logToServer } from "../logger";

function KmcForget() {
  const navigate = useNavigate();
  const [member_email, setUserEmail] = useState("");
  const [enter, SetEnter] = useState(false);
  const [reset, setReset] = useState(false);
  const [shouldSignUp, setShouldSignUp] = useState(false);
  const [isVerified, setisVerified] = useState(false);
  const [pass, setPass] = useState("");
  const [cPass, setCpass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { setUserInfo, userInfo, getCsrfToken } = useContext(GlobalContext);
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d#@]{8,}$/;

  // useEffect(()=>{
  //   if(userInfo){
  //     navigate("/projects")
  //   }
  // },[])

  const sendOTP = async (e) => {
    e.preventDefault();
    if (!member_email) {
      toast.warn("Please enter email");
      return;
    }
    const key = sessionStorage.getItem("optkey");
    let url = !key
      ? `${HOST}/send-otp/${member_email}`
      : `${HOST}/send-otp-key/${member_email}/${key}`;
    const csrftoken = document.cookie
      .split("; ")
      .find((row) => row.startsWith("csrftoken="));
    try {
      const res = await fetch(url, {
        method: "POST",
        credentials: "include",
        body: {},
      });

      const data = await res.json();

      if (res.status === 400 || res.status === 500 || !data || data.error) {
        SetEnter(false);
        logToServer("error", "Error sending OTP");
        toast.error("Error sending OTP. Please try again");
      } else if (res.status === 200) {
        toast.success(`OTP sent successfully`);
        SetEnter(true);
        setShouldSignUp(false);

        logToServer("info", "OTP sent successfully");
        sessionStorage.setItem("otpkey", data.key);
        const expirationTime = new Date().getTime() + 1 * 60 * 1000;
        sessionStorage.setItem(`otp_expiration`, expirationTime);
        sessionStorage.setItem(`email`, member_email);

        // setReset(true)
        // try {
        //   toast.success(`Welcome ${data.user_info.name}`);
        //   await new Promise(resolve => setTimeout(resolve, 2000)); // Wait for 2 seconds
        //   navigate("/projects");
        // } catch (error) {
        //   console.error("Error navigating to welcome page:", error);
        // }
        // return;
      }
    } catch (e) {
      toast.error("Invalid credentials");
      logToServer("error", `${e}`);
    }
  };

  async function resetPass(e) {
    e.preventDefault();
    const email = sessionStorage.getItem("email");
    if (pass && cPass && pass !== "" && cPass !== "") {
      if (pass === cPass) {
        if (passwordRegex.test(pass) && pass.length >= 8) {
          try {
            const res = await fetch(`${HOST}/reset-password`, {
              method: "POST",
              credentials: "include",
              body: JSON.stringify({ data: { email: email, password: pass } }),
              headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": await getCsrfToken(),
              },
            });

            if (res.status === 400) {
              toast.error("Password reset failed");
              logToServer("error", "password reset Failed");
            } else if (res.status === 200) {
              toast.success("Password Reset Successfully");
              logToServer("info", "password Reset Successfully");

              sessionStorage.removeItem("email");
              setTimeout(() => {
                navigate("/kmc-login");
              }, 2000);
            }
          } catch (e) {
            toast.error("Unexpected error occured. Please try again");
            logToServer("error", `${e}`);
          }
        } else {
          toast.warn(
            "Password should contain at least one uppercase letter, one lowercase letter, one digit, and be at least 8 characters long"
          );
        }
      } else {
        toast.error("Password and Comfirm Password don't match");
      }
    } else {
      toast.error("Please enter Password and Comfirm Password");
    }
  }

  return (
    <>
 
      {/* Blurred background with dark overlay */}
      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/${files}kmc-bg.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(5px)",
          zIndex: 0,
        }}
      ></div>

      {/* Dark overlay on top of the background */}
      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
        }}
      ></div>

        {/* Centered form container */}
        <div
          className="position-fixed top-50 start-50 translate-middle d-flex justify-content-center align-items-center w-100 h-100"
          style={{ zIndex: 2 }}
        >
          <div
            className="bg-light bg-opacity-75 p-5 rounded shadow d-flex flex-column align-items-center"
            style={{
              width: "100%",
              maxWidth: "550px",
              height: "auto", // Let form expand dynamically
            }}
          >
            {/* Logo */}
            <div className="text-center">
              <img
                src={`${process.env.PUBLIC_URL}/${files}KMC_logo.png`}
                alt="Vasundharaa Logo"
                className="img-fluid"
                style={{ maxHeight: "120px" }}
              />
            </div>

            {/* Your form here */}
            <form className="login-form w-100">
              {!enter && (
                <>
                  <input
                    type="email"
                    className="form-control mb-3 text-dark"
                    value={member_email}
                    onChange={(e) => setUserEmail(e.target.value)}
                    placeholder="Enter email"
                    required
                  />

                  <button
                    type="submit"
                    className="btn btn-primary w-100 mb-1"
                    onClick={(e) => sendOTP(e)}
                  >
                    Send OTP
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary w-100"
                    onClick={() => navigate("/kmc-login")}
                  >
                    Back
                  </button>
                </>
              )}

              {reset && (
                <div className="mt-4">
                  <div className="position-relative mb-3">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control pe-5 text-dark"
                      value={pass}
                      onChange={(e) => setPass(e.target.value)}
                      placeholder="New password"
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-sm position-absolute"
                      style={{
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                      }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={`fa ${
                          showPassword ? "fa-eye-slash" : "fa-eye"
                        }`}
                      />
                    </button>
                  </div>

                  <div className="position-relative mb-3">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control pe-5 text-dark"
                      value={cPass}
                      onChange={(e) => setCpass(e.target.value)}
                      placeholder="Confirm password"
                      required
                    />
                    <button
                      type="button"
                      className="btn btn-sm position-absolute"
                      style={{
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        border: "none",
                        background: "transparent",
                      }}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      <i
                        className={`fa ${
                          showConfirmPassword ? "fa-eye-slash" : "fa-eye"
                        }`}
                      />
                    </button>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary w-100 mb-1"
                    onClick={(e) => resetPass(e)}
                  >
                    Reset Password
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary w-100"
                    onClick={() => {
                      SetEnter(false);
                      setReset(false);
                    }}
                  >
                    Back
                  </button>
                </div>
              )}
            </form>

            {/* OTP Section */}
            {enter && !reset && (
              <div className="w-100">
                <OTP
                  setReset={setReset}
                  SetEnter={SetEnter}
                  setShouldSignUp={setShouldSignUp}
                  setisVerified={setisVerified}
                  sendOTP={sendOTP}
                />
              </div>
            )}
          </div>
        </div>
      

      <ToastContainer
        position="bottom-right"
        theme="colored"
        draggable={false}
      />
    </>
  );
}

export default KmcForget;